import C from '../actions/constants'

export const files = (state = [], action) => {
    switch (action.type) {
        case C.SET_FILES:
            return action.payload
        default:
            return state
    }
}